import { ApplicationRef, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomImageTooltip } from '@common-standalone/image-tooltip/image-tooltip.component';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { IcloudBackupController } from '@mainrepo/app/core/controller/icloudBackupController';
import { ColDef } from 'ag-grid-community';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { WEBVIEW_MESSAGES } from '../constants/WEBVIEW_MESSAGES';
import { ActiveRepo, UniversalService } from '../services/universal.service';
import { ContextMenuService } from './context-menu.service';
import { GlobalService } from './global.service';
import { LocalStorageSvc } from './localStorage.service';

declare var jQuery: any;

@Injectable({
  providedIn: 'root'
})
export class ListService {
  public rowData:any =  [];
  public allRowsData : any = [];
  public listOptions: any;
  public addToJCOptions: any;
  public moveCopyOptions:any;
  public audioMobilePlayList:any;
  public audioPreviewOptions:any;
  // public sentFileOptions:any;
  // public ReceivedFileOptions:any;
  public nextDataUrl: any;
  public gridApi: any;
  public gridData: any;
  public openFolderContent: boolean = false;
  public previousDataUrl:string = "";
  public audiosRowDataSet: boolean = false;
  public docsRowDataSet:boolean = false;
  public cellclick :boolean = false;
  public idsArray:any=[];
  public noAlbumsPresent :boolean = false;
  public noFoldersPresent : boolean = false;
  public sortType="asc";
  public listViewSortOrder:string="";
  public sharedLinkByMeSortOrder:string="&sort=%2DcreatedDate";
  public headerCheckBoxChecked:boolean = false;
  public disableSelectionModeInListView = false;
  public deselectedNodesArray:any = [];
  public cdstr:any;
  public parentFolderKey:string = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
  public foldercount =0;
  public filecount =0;
  public createFolderObject: boolean = false;
  public createAlbumObject: boolean = false;
  public objectDetails:any = {};
  public fileInfoRenameValue:any;
  static listServiceRef: any;
 
  public comparator = (valueA, valueB) => {
  // return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};
public Sizecomparator = (valueA, valueB) =>{
  // var size1 = valueA.split(" ")[1];
  // var size2 = valueB.split(" ")[1];
  // if(size1 == "B"|| size2 == "B"){
  //   valueA = parseInt(valueA);
  //   valueB = parseInt(valueB);
  // }
  // if(size1 == "KB"){
  //   valueA = parseInt(valueA)*1024
  // }else if(size1 == "MB"){
  //   valueA = parseInt(valueA)*1024*1024
  // }else if(size1 == "GB"){
  //   valueA = parseInt(valueA)*1024*1024*1024
  // }
  // if(size2 == "KB"){
  //   valueB = parseInt(valueB)*1024
  // }else if(size2 == "MB"){
  //   valueB = parseInt(valueB)*1024*1024
  // }else if(size2 == "GB"){
  //   valueB = parseInt(valueB)*1024*1024*1024
  // }
  // if(valueA == valueB){
  //   return 0;
  // }else if(valueA > valueB){
  //   return 1; 
  // }else if (valueA < valueB){
  //   return -1;
  // }
}
  listViewSortOrderShare: any;
  icloudImplRef: any;
  IcloudBackupController: any;

public dateComparator(valueA,valueB){
//   var date1 = valueA.split(" ");
//   var date2 = valueB.split(" ");
//   if(!date1[2]){
//     valueA = valueA +" " + new Date().getFullYear();
//   }
//   if(!date2[2]){
//     valueB = valueB + " " + new Date().getFullYear();
//   }
//   valueA = Date.parse(valueA);
//   valueB = Date.parse(valueB);
//   if(valueA == valueB){
//     return 0;
//   }else if(valueA > valueB){
//     return 1; 
//   }else if (valueA < valueB){
//     return -1;
//   }
}
public uploadDateComparator(valueA,valueB){

}




public recentFilesDefs = [ //recent files list view definitions
  { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
  { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
  { headerName: 'Name',field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: false, width: 100,comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';} },
  { headerName: 'Size', field: 'size', sortable: false, width: 65, suppressMovable:true,resizable:false  },
  { headerName: 'Type', field: 'type', sortable: false, width: 65,comparator:this.comparator,suppressMovable:true,resizable:false },  
  { headerName: 'Accessed', field: 'accessed',  sortable: false, width: 65, suppressMovable:true,resizable:false },
]
  public audioDefs = [ // audio files list view definitions after login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name',field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 150,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName' ,cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';}},
    { headerName: 'Duration', field: 'duration',  width: 65, suppressMovable:true,sortable:false,resizable:false},    
    { headerName: 'Created', field: 'created',  sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator,suppressMovable:true,resizable:false },
    { headerName: 'Uploaded', field: 'uploaded',  sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.uploadDateComparator,suppressMovable:true,resizable:false },
  ]


  public audioPreviewDefs = [ // audio files preview list view definitions after login
    { headerName: '', field: 'ImagePath', cellRenderer: this.customCellRendererFunc, width: 80},
    { headerName: '',field: 'name', cellRenderer: this.customNameCellRendererFunc,   sortable: true, width: 460, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, cellStyle: {'left':'50px' },cellClass: params => {return ' agGridAudioPreviewDefsObjectNameLeft';}},
    { headerName: '', field: 'duration',   sortable: false, width: 90 },
    { headerName: '', field: 'equalizer', cellRenderer: this.equalizerRendererFunc, width: 80,cellClass:'agGridEqualizer'},
    { headerName: '', field: '',  width: 120 },
  ]

  public preLoginAudioDefs = [ // audio files list view definitions before login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name',field: 'name', cellRenderer: this.customNameCellRendererFunc,   sortable: true, width: 230,sortingOrder: ['asc', 'desc'],comparator:this.comparator,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';}, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false} },
    { headerName: 'Duration', field: 'duration',   sortable: false, width: 50  },    
    { headerName: 'Created', field: 'created',   sortable: true, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator },
  ]
  public allFilesDefs = [ // all files list view after login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 100,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px !important' },headerClass: 'agGridHeaderName',cellClass:params => {if(params.data["FullObject"]["objectType"]=="FR" || params.data["FullObject"]["objectType"]=="BR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}}},
    { headerName: 'Size', field: 'size', sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.Sizecomparator, suppressMovable:true,resizable:false},
    { headerName: 'Type', field: 'type',  sortable: false, width: 65,comparator:this.comparator, suppressMovable:true,resizable:false },
    { headerName: 'Created', field: 'created', sortable: true,   width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false },
    { headerName: 'Uploaded', field: 'uploaded',   sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.uploadDateComparator, suppressMovable:true,resizable:false},
  ];

  public trashFilesDefs = [ // all files list view after login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 160,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px !important' },headerClass: 'agGridHeaderName',cellClass:params => {if(params.data["FullObject"]["objectType"]=="FR" || params.data["FullObject"]["objectType"]=="BR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}}},
    { headerName: 'Size', field: 'size', sortable: false, width: 50,comparator:this.Sizecomparator, suppressMovable:true,resizable:false},
    { headerName: 'Type', field: 'type',  sortable: false, width: 50,comparator:this.comparator, suppressMovable:true,resizable:false },
    { headerName: 'Created', field: 'created', sortable: true,   width: 65,sort:'desc',sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false },
    { headerName: 'Deleted', field: 'lastAccessCol',   sortable: false, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.uploadDateComparator, suppressMovable:true,resizable:false},

  ];

  public preLoginAllFilesDefs = [ // all files list view before login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 200,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName' ,cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';} },
    { headerName: 'Size', field: 'size',  sortable: true, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.Sizecomparator,suppressMovable:true,resizable:false },
    { headerName: 'Type', field: 'type',  sortable: true, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.comparator,suppressMovable:true,resizable:false },
    { headerName: 'Created', field: 'created', sortable: true,   width: 50,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator,suppressMovable:true,resizable:false },
  ];
  public addToJCColumnDefs = [ // add to JC my files for desktop
    { headerName: '', field: 'ImagePath', cellRenderer: this.customCellRendererFunc, width: 75,  checkboxSelection: true },
    { headerName: '', field: 'fileName',   sortable: true, width: 300,cellClass:'addToJCFileNameCell'},
  ]
  public columnMobileDefs1 = [ // add to JC my files for mobile
    { headerName: '', field: 'ImagePath', cellRenderer: this.customCellRendererFunc, width: 90,  checkboxSelection: true },
    { headerName: '', field: 'fileName',   sortable: false, width: 300,cellClass:'addToJCFileNameCell'},
  ]

  public DocsDefs = [ // documents list view after login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', width: 100, cellRenderer: this.customNameCellRendererFunc,   sortable: true,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';} },
    { headerName: 'Type', field: 'type', width: 65, sortable: false,comparator:this.comparator, suppressMovable:true,resizable:false },
    { headerName: 'Size', field: 'size',   sortable: true, width: 30,sortingOrder: ['asc', 'desc'],comparator:this.Sizecomparator, suppressMovable:true,resizable:false},
    { headerName: 'Created', field: 'created',   sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false},
    { headerName: 'Uploaded', field: 'uploaded',   sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.uploadDateComparator, suppressMovable:true,resizable:false},
    { headerName: 'Modified', field: 'modified',  sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.uploadDateComparator, suppressMovable:true,resizable:false},

  ]
  public preLoginDocsDefs = [ // documents list view before login
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,   sortable: true, width: 200,sortingOrder: ['asc', 'desc'],comparator:this.comparator,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';} },
    { headerName: 'Size', field: 'size',   sortable: true, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.Sizecomparator},
    { headerName: 'Created', field: 'created',   sortable: true, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator},
  ]

  public moveCopyDefs = [ // move,copy definitions
    { headerName: '', field: 'ImagePath', cellRenderer: this.customCellRendererFunc, width: 75,  checkboxSelection: true },
    { headerName: '', field: 'fileName',   sortable: true, width: 300,cellClass:'moveCopyFileNameCell'},
  ]

  public moveCopyMobileDefs = [ // move copy for mobile
    { headerName: '', field: 'ImagePath', cellRenderer: this.customCellRendererFunc, width: 110,  checkboxSelection: true },
    { headerName: '', field: 'fileName',   sortable: true, width: 270,cellClass:'moveCopyFileNameCell',},
  ]

  public FavoritesDefs = [ // favorited list view
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name',field: 'name', cellRenderer: this.customFavoriteTabCellRendererFunc,   sortable: false, width: 100,comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName' ,cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';}},
    { headerName: 'Size', field: 'size',   sortable: false, width: 65 , suppressMovable:true,resizable:false },
    { headerName: 'Type', field: 'type',  sortable: false, width: 65,comparator:this.comparator, suppressMovable:true,resizable:false },  
    { headerName: 'Starred', field: 'starred',   sortable: false, width: 65, suppressMovable:true,resizable:false },
  ]

  public SharedWithMeDefs = [ // shared with me default list view
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 60,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false},suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {if(params.data["FullObject"]["objectType"]=="FR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}} },
    { headerName: 'Shared by', field: 'sharedBy',cellRenderer: this.customOwnerNameCellRendererFunc,  sortable: false, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.comparator,tooltipField:'sharedBy',suppressMovable:true,resizable:false, tooltipComponentParams: {isCustomToolTipRequired: false,'tooltipReqFor':'sharedBy'}},
    { headerName: 'Last Modified', field: 'modified', sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator,suppressMovable:true,resizable:false },
    { headerName: 'Share Date', field: 'shareDate', sortable: true, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator,suppressMovable:true,resizable:false },
  ]

  public SharedByMeDefs = [ // shared by me default list view
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 100,sortingOrder: ['asc', 'desc'],comparator:this.comparator, tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false},suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {if(params.data["FullObject"]["objectType"]=="FR" || params.data["FullObject"]["objectType"]=="BR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}}},
    { headerName: 'Owner', field: 'owner', cellRenderer: this.customOwnerNameCellRendererFunc,  sortable: false, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.comparator,suppressMovable:true,resizable:false ,tooltipField:'owner',tooltipComponentParams: {isCustomToolTipRequired: false,'tooltipReqFor':'owner'}},
    { headerName: 'Size', field: 'size',  sortable: false, width: 65,sortingOrder: ['asc', 'desc'],comparator:this.Sizecomparator,suppressMovable:true,resizable:false },
    { headerName: 'Last Modified', field: 'modified', sortable: true,   width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator ,suppressMovable:true,resizable:false},
    { headerName: 'Share Date', field: 'shareDate', sortable: true,   width: 65,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator,suppressMovable:true,resizable:false },
  ];

  public searchResultsDef = [ // search results list view
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: false, width: 200,sortingOrder: ['asc', 'desc'],comparator:this.comparator,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {return ' agGridAllFilesDefObjectNameLeft';}},
    { headerName: 'Size', field: 'size',  sortable: false, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.Sizecomparator, suppressMovable:true,resizable:false},
    { headerName: 'Type', field: 'type',  sortable: false, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.comparator, suppressMovable:true,resizable:false },
    { headerName: 'Created', field: 'created', sortable: false,   width: 60,sort:'desc',sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false },
  ];

  public sharedLinkByMeDef = [ // sharedlinkbyme list view before login
    { headerName: 'Name', field: 'shareName', cellRenderer: this.customCellImageNameRendererFunc,  sortable: true, width: 200,sortingOrder: ['asc', 'desc'],comparator:this.comparator,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false},
    { headerName: 'Date Created', field: 'createdDate', sortable: true,  width: 200, sort:'desc' ,sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false },
    { headerName: '', field: 'icon', cellRenderer: this.customIconCellRendererFunc, sortable: false,  width: 10, suppressMovable:true,resizable:false },
  ];

  public teamFoldersRootDefs = [ // team folders list view
    { headerName: '', field: 'ImagePath', cellRenderer: this.customCellRendererFunc, width: 60,  checkboxSelection: false, headerCheckboxSelection: false, suppressMovable:true,resizable:false },
    { headerName: 'Name', field: 'name',sortable:false, cellRenderer: this.customNameCellRendererFunc,   width: 300,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,headerClass: 'teamFoldersRootHeaderName',cellClass: params => {if(params.data["FullObject"]["objectType"]=="FR"){return "cellId-" + params.data.objectId + " teamfolderRootCells";}}},
    { headerName: 'Size', field: 'size', sortable: false,   width: 500, suppressMovable:true,resizable:false },
    { headerName: '', field: 'icon', cellRenderer: this.customIconCellRendererFunc, sortable: false,   width: 200, suppressMovable:true,resizable:false },
  ]
  
  public teamFolderContentDefs = [
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: true, width: 200,sortingOrder: ['asc', 'desc'],comparator:this.comparator,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {if(params.data["FullObject"]["objectType"]=="FR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}}},
    { headerName: 'Created by', field: 'createdByName', cellRenderer:this.customcretedBymeCellRendererFuncTeamFolder, width: 60, suppressMovable:true,sortable:false,resizable:false, tooltipField:'createdByName',tooltipComponentParams: {isCustomToolTipRequired: false,'tooltipReqFor':'createdByName'}},
    { headerName: 'Size', field: 'size',  width: 50, suppressMovable:true,resizable:false,comparator:this.Sizecomparator,sortingOrder: ['asc', 'desc'],sortable:false },
    { headerName: 'Type', field: 'type',  width: 50, suppressMovable:true,resizable:false,comparator:this.comparator, sortingOrder: ['asc', 'desc'],sortable:false },
    { headerName: 'Created', field: 'created', sortable: true,   width: 60,sort:'desc',sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false },
  ]

  public teamFolderSearchContentDefs = [
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name', cellRenderer: this.customNameCellRendererFunc,  sortable: false, width: 200,comparator:this.comparator,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,cellStyle: {'left':'107px' },headerClass: 'agGridHeaderName',cellClass: params => {if(params.data["FullObject"]["objectType"]=="FR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}}},
    { headerName: 'Created by', field: 'createdByName',tooltipField:'createdByName',    width: 60, suppressMovable:true,sortable:false,resizable:false, tooltipComponentParams: {isCustomToolTipRequired: false}},
    { headerName: 'Size', field: 'size',  width: 50, suppressMovable:true,comparator:this.Sizecomparator,sortable:false,resizable:false },
    { headerName: 'Type', field: 'type',  width: 50, suppressMovable:true,comparator:this.comparator, sortable:false,resizable:false },
    { headerName: 'Created', field: 'created', sortable: false, width: 60,sort:'desc',comparator:this.dateComparator, suppressMovable:true,resizable:false },
  ]

  public teamFoldersTrashDefs = [ // team folders list view
    { headerName: '', field: 'selectIcon',  width: 20,  checkboxSelection: true, headerCheckboxSelection: true, suppressMovable:true,resizable:false },
    { headerName: '', field: 'ImagePath', width: 20, cellRenderer: this.customCellRendererFunc, checkboxSelection: false, headerCheckboxSelection: false, tooltipField:'ImagePath', tooltipComponentParams: {isCustomToolTipRequired: true}, suppressMovable:true,resizable:false, cellStyle: {'left':'57px' }, cellClass: params => {return ' agGridDefImagePathLeft';} },
    { headerName: 'Name', field: 'name',sortable:false, cellRenderer: this.customNameCellRendererFunc,   width: 200,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false,headerClass: 'agGridHeaderName',cellStyle: {'left':'107px' },cellClass: params => {if(params.data["FullObject"]["objectType"]=="FR"){return "cellId-" + params.data.objectId + ' agGridAllFilesDefObjectNameLeft';} else{ return ' agGridAllFilesDefObjectNameLeft'}}},
    { headerName: 'Deleted by', field: 'deletedby',sortable:false,   width: 100,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,resizable:false},
    { headerName: 'Size', field: 'size', sortable: false,   width: 50, suppressMovable:true,resizable:false },
    { headerName: 'Type', field: 'type',  sortable: false, width: 50,sortingOrder: ['asc', 'desc'],comparator:this.comparator, suppressMovable:true,resizable:false },
    { headerName: 'Deleted', field: 'deleted', sortable: true,   width: 60,sort:'desc',sortingOrder: ['asc', 'desc'],comparator:this.dateComparator, suppressMovable:true,resizable:false },
  ]
  
  public icloudBcakupStatus = [
    { headerName: '', field: 'ImagePath', cellRenderer: this.customIcloudFileIconRenderedFunc, width: 40,  checkboxSelection: false, headerCheckboxSelection: false, suppressMovable:true,resizable:false },
    { headerName: 'File Name', field: 'name',  sortable: false, width: 200,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,cellStyle: {'left':'35px' },headerClass: 'icloudFileNameHeader',cellClass:'agGridCloudBridgeDefObjectNameLeft',resizable:false},
    { headerName: 'Size', field: 'size', sortable: false, width: 50, suppressMovable:true,resizable:false},
    { headerName: 'Status', field: 'status',  sortable: false, width: 50, suppressMovable:true,resizable:false },
  ];
  public icloudBcakupStatusMob =[
    { headerName: '', field: 'ImagePath', cellRenderer: this.customIcloudFileIconRenderedFunc, width: 1,  checkboxSelection: false, headerCheckboxSelection: false },
    { headerName: 'File Name', field: 'name',  sortable: false, width: 70,tooltipField:'name',cellStyle: {'left':'20px' },headerClass: 'icloudFileNameHeader',cellClass:'agGridCloudBridgeDefMobileObjectNameLeft'},
    { headerName: 'Size', field: 'size', sortable: false, width: 70 ,cellClass:'agGridCloudBridgeDefMobileObjectSizeLeft',headerClass: 'icloudFileSizeHeader'},
    { headerName: 'Status', field: 'status',  sortable: false, width: 70,cellClass:'agGridCloudBridgeDefMobileObjectStatusLeft',headerClass: 'icloudFileStatusHeader'},
  ]
  public hideSizeColumnForGPhotos = [
    { headerName: '', field: 'ImagePath', cellRenderer: this.customIcloudFileIconRenderedFunc, width: 40,  checkboxSelection: false, headerCheckboxSelection: false, suppressMovable:true,resizable:false },
    { headerName: 'File Name', field: 'name',  sortable: false, width: 200,tooltipField:'name', tooltipComponentParams: {isCustomToolTipRequired: false}, suppressMovable:true,cellStyle: {'left':'35px' },headerClass: 'icloudFileNameHeader',cellClass:'agGridCloudBridgeDefObjectNameLeft',resizable:false},
    { headerName: 'Status', field: 'status',  sortable: false, width: 50, suppressMovable:true,resizable:false },
  ];
  public hideSizeColumnForGPhotosMob =[
    { headerName: '', field: 'ImagePath', cellRenderer: this.customIcloudFileIconRenderedFunc, width: 1,  checkboxSelection: false, headerCheckboxSelection: false },
    { headerName: 'File Name', field: 'name',  sortable: false, width: 70,tooltipField:'name',cellStyle: {'left':'20px' },headerClass: 'icloudFileNameHeader',cellClass:'agGridCloudBridgeDefMobileObjectNameLeft'},
    { headerName: 'Status', field: 'status',  sortable: false, width: 70,cellClass:'agGridCloudBridgeDefMobileObjectStatusLeft',headerClass: 'icloudFileStatusHeader'},
  ]

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    tooltipComponent: CustomImageTooltip,
  };


  public equalizerRendererFunc(params): string {
    // $("#audios-list-ag-grid").find('.agGridEqualizer span div').empty();
    // const assetsPath = params.data.options;
    let cellContent: string = '';
    // cellContent += "<ng-lottie class='audio_equalizer' [options]='"+assetsPath+"' containerClass='moving-box' (animationCreated)='animationCreated($event)'></ng-lottie>";
    cellContent += "<div id='lottie_"+params.data.objectId+"' ></div>"
    return cellContent;
  }

  options: AnimationOptions = {
    path: 'assets/bg_animation.json',
    //path: 'https://assets2.lottiefiles.com/packages/lf20_fq60ombf.json'
  };
  animationCreated(animationItem: AnimationItem): void {
    console.log("animationItem:",animationItem);
  }
  public customIcloudFileIconRenderedFunc(){
    let cellContent: string = '';
    cellContent += '<span class="NeueOtherFiles icloudOtherFileIcon" ></span>'
    return cellContent
  }
  public  customCellImageNameRendererFunc(params): string {
    let cellContent: string = '';
    let imagePath = params.data.ImagePath;
    let objType = params.data.type;
    const shareType = params.data.FullObject.shareType;
    const isShared = params.data.FullObject.isShared;
    const shareURL = params.data.FullObject.shareURL;
    const folderName = params.data.FullObject.objectName;
    let mimeSubType = params.data.FullObject.mimeSubType;
    const grid = params.data.addToJiocloudgFolderItem;
    const format = params.data.FullObject.format;
    const docImage = params.data.FullObject.MSOfficeImage
    if(params.data.FullObject["shareCategory"] && params.data.FullObject["shareCategory"] == "S" && objType != "Image" && objType != "Audio" && objType != "Video" && params.data.FullObject["objectType"] == "FE") { // we are supposed to show default application tile for shared by me links
      objType = "application";
      mimeSubType="application";
    }
    if (!grid) {
      // if not addToJiocloud modal open
    }

    if (objType == 'Album' && imagePath.includes("/albums")) {
      cellContent += '<img src="' + imagePath + '" style="border-radius: 10px;width:100px;height: 70px;" onerror="this.onerror=null;this.src="" style="border:2px solid #ccc">'
    } else if (objType == 'Album' && !(imagePath.includes("/albums"))) {
      if (imagePath == "invalidUrl") {
        cellContent += '<span class="emptyBoardPic" style="border-radius: 10px;width:60px;height: 65px;border:1px solid #ccc;"></span>'
      } else {
        cellContent += '<span class="emptyBoardPic" style="border-radius: 10px;width:60px;height: 65px;border:2px; background-color:' + imagePath + '"' + '></span>'
      }
    }else if (objType == 'Audio') {
       cellContent += '<span class="audioAlbumPoster" style="background-image: url('+imagePath+');"></span>'
        cellContent += '<span class="NeueAudio defaultAudioPoster"></span>'
        cellContent += '<span class="NeuePlayFilledEllipse defaultAudioPoster onHoverOnly"></span>'
    }else if (objType == 'Image' ) {
      cellContent += '<span class="NeueImageFilled defaultImgPoster"></span>';
      cellContent += '<span class="videoAlbumPoster" style="background-image: url('+imagePath+');"></span>';

    }else if (objType == 'Video') {
      cellContent += '<span class="MSDocumentImages videoImages" style="background-image: url(assets/images/video.svg);"></span>';
      cellContent += '<span class="videoAlbumPoster" style="background-image: url('+imagePath+');"></span>';
      // cellContent += '<span class="NeuePlayFilled defaultAudioPoster" style="background-color:#10B3FC"></span>'
      
    } else if (objType == 'Folder') {
      var folderIcon = "";
      if(shareType == 'R' && isShared == true){
        folderIcon = "NeueSharedFolder"
      }else if (params.data.tfKey && params.data.FullObject["tfType"] == "R"){
        folderIcon = "NeueFolder_Locked"
      }else{
        folderIcon = "NeueFolderFilled"
      }
      if (grid) {
        cellContent += '<span class="' + folderIcon + ' font-prop mr-3" ></span>'
      } else {
        cellContent += '<span class="' + folderIcon + ' listFolder" title="' + folderName + '"></span>'
      }
    } else if (objType == 'Document' || mimeSubType == 'msword' || objType == 'Word' || format == "Document") {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'SpreadSheet' || objType == 'Excel' || format == 'SpreadSheet') {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'Presentation' || mimeSubType == 'vnd.ms-powerpoint'|| objType == 'PowerPoint' || format == 'PowerPoint') {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'MSOfficeDocument' ||format == 'MSOfficeDocument') {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'PDF' || format == 'PDF') {
      // cellContent += '<span class="NeuePDFFilled pdfListViewIcon" style="" ></span>'
      cellContent += '<span class="MSDocumentImages PDFImages" style="background-image: url(assets/images/pdf.svg);"></span>';
    } else if (objType == 'Text' || objType == 'HTML' || format == 'text') {
      // cellContent += '<span class="NeueTXTFilled textListViewIcon" style="" ></span>'
      cellContent += '<span class="MSDocumentImages txtImages" style="background-image: url(assets/images/txt-square.svg);"></span>';
    } else {
      cellContent += '<span class="NeueOtherFiles othersListViewIcon test" ></span>'
    }

    if (objType == 'Image' || objType == 'Audio' || objType == 'Video') {
      cellContent = '<div class="icon-container icon-image-container">' + cellContent + '</div>';
    } else {
      cellContent = '<div class="icon-container">' + cellContent + '</div>';
    }

    let nameCellContent:string = '';
    let nameCellClass:string = 'public-sharelink';
    const fileName = params.data.name;
    nameCellContent  +='<span class="fileNameCont mb-3"><a href="' + shareURL + '" target="_blank" rel="noopener noreferrer">'+ fileName +'</a></span>' 

    if(params.data.FullObject["isPassProtected"]){
      nameCellClass = 'public-protected-sharelink';
      nameCellContent  +='<span class="Neuelock_filled img-sharelink-icon-bg position-absolute"></span>'
      //Neueunlock_filled
    } 

    if(params.data.drag && params.data.drag == true){
      $(".ag-row").attr("draggable","true");
    }else{
      $(".ag-row").attr("draggable","false");
    }

    return '<div class="sharelink-name">' + cellContent + '<span class="position-relative '+ nameCellClass +'" >' + nameCellContent + '</span>' + '</div>';
  }

  public customIconCellRendererFunc(params): string {
    let cellContent: string = '';
    return cellContent  = '<span class="NeueMore_Options position-absolute cursor-pointer"></span>'
  }
  public customcretedBymeCellRendererFuncTeamFolder(params): string {
    let cellContent: string = '';
    const createdBy = params.data.createdByName
    return cellContent  = '<span class="created-by-user-name">' + createdBy +'</span>'
  }
  public customCellRendererFunc(params): string {
    let cellContent: string = '';
    const imagePath = params.data.ImagePath;
    const objType = params.data.type.toLowerCase();
    const shareType = params.data.FullObject.shareType;
    const isShared = params.data.FullObject.isShared;
    const recipientCount = params.data.FullObject.isShared;
    const folderName = params.data.FullObject.objectName;
    const mimeType = params.data.FullObject.mimeType;
    const mimeSubType = params.data.FullObject.mimeSubType;
    const grid = params.data.addToJiocloudgFolderItem;
    const format = params.data.FullObject.format;
    const docImage = params.data.FullObject.MSOfficeImage;
    if (!grid) {
      // if not addToJiocloud modal open
    }
    if (objType == 'album' && imagePath.includes("/albums")) {
      cellContent += '<img src="' + imagePath + '" style="border-radius: 10px;width:100px;height: 70px;" onerror="this.onerror=null;this.src="" style="border:2px solid #ccc">'
    } else if (objType == 'album' && !(imagePath.includes("/albums"))) {
      if (imagePath == "invalidUrl") {
        cellContent += '<span class="emptyBoardPic" style="border-radius: 10px;width:60px;height: 65px;border:1px solid #ccc;"></span>'
      } else {
        cellContent += '<span class="emptyBoardPic" style="border-radius: 10px;width:60px;height: 65px;border:2px; background-color:' + imagePath + '"' + '></span>'
      }
    }else if (objType == 'audio') {
       cellContent += '<span class="audioAlbumPoster" style="background-image: url('+imagePath+');"></span>'
        cellContent += '<span class="NeueAudio defaultAudioPoster"></span>'
        cellContent += '<span class="NeuePlayFilledEllipse defaultAudioPoster onHoverOnly"></span>'
    }else if (objType == 'image' ) {
      let customeClassName = ''
      if(mimeSubType == 'gif'){
        customeClassName = 'gifStyle'
      }
      if(mimeType != 'application') {
        cellContent += '<span class="videoAlbumPoster '+customeClassName+'" style="background-image: url('+imagePath+');"></span>'
      }
      cellContent += '<span class="NeueImageFilled defaultImgPoster"></span>'

    }else if (objType == 'video') {
      cellContent += '<span class="MSDocumentImages videoImages" style="background-image: url(assets/images/video.svg);"></span>'
      cellContent += '<span class="videoAlbumPoster" style="background-image: url('+imagePath+');"></span>';
      // cellContent += '<span class="NeuePlayFilled defaultAudioPoster" style="background-color:#10B3FC"></span>';
      
    } else if (objType == 'folder') {
      var folderIcon = "";
      if(shareType == 'R' && isShared == true){
        folderIcon = "NeueSharedFolder"
      }else if (params.data.FullObject.tfKey && params.data.FullObject["tfType"] == "R"){
        folderIcon = "NeueFolder_Locked"
      }else{
        folderIcon = "NeueFolderFilled"
      }
      if (grid) {
        cellContent += '<span class="' + folderIcon + ' font-prop mr-3" ></span>'
      } else {
        cellContent += '<span class="' + folderIcon + ' listFolder" title="' + folderName + '"></span>'
      }
    } else if (objType == 'document' || mimeSubType == 'msword' || objType == 'word' || format == "Document") {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'spreadsheet' || objType == 'excel' || format == "SpreadSheet") {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'MSOfficeDocument' || format == "MSOfficeDocument") {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'presentation' || mimeSubType == 'vnd.ms-powerpoint'|| objType == 'powerpoint' || format == "Presentation") {
      cellContent += '<span class="MSDocumentImages" style="background-image: url('+docImage+');"></span>'
    } else if (objType == 'pdf' || format == "PDF") {
      // cellContent += '<span class="videoAlbumPoster" style="background-image: url('+imagePath+');"></span>'
      // cellContent += '<span class="NeuePlayFilled defaultAudioPoster" style="background-color:#10B3FC"></span>'
      // cellContent += '<span class="NeuePDFFilled pdfListViewIcon" style="" ></span>'
      cellContent += '<span class="MSDocumentImages PDFImages" style="background-image: url(assets/images/pdf.svg);"></span>'
    } else if (objType == 'text' || format == "text") {
      // cellContent += '<span class="NeueTXTFilled textListViewIcon" style="" ></span>'
      cellContent += '<span class="MSDocumentImages txtImages" style="background-image: url(assets/images/txt-square.svg);"></span>'
    } else {
      cellContent += '<span class="NeueOtherFiles othersListViewIcon" ></span>'
    }

    return cellContent;
  }

  public backupsCellRendererFunc(params): string {
    let cellContent: string = '';
    const imagePath = params.data.ImagePath;
    cellContent += '<span class="backupFolder" style="background-image: url('+imagePath+');"></span>'
    return cellContent;
  }


  // public teamfolderCellRendererFunc(params): string {
  //   let cellContent: string = '';
  //   const folderName = params.data.name;
  //   const members = params.data.members;
  //   // cellContent += '<span class="NeueFolderFilled listFolder" title="' + folderName + '"></span>';
  //   let nameCellContent:string = '';
  //   // nameCellContent  +='<span '+'class="folderNameCont" title="'+folderName+'">'+folderName+'</span>';
  //   // if(members == 1) nameCellContent  +='<span '+'class="folderNameCont" >'+members+' Member </span>';
  //   // else nameCellContent  +='<span '+'class="folderNameCont" >'+members+' Members </span>'
  //   // return '<div class="sharelink-name">' + cellContent + '<span class="position-relative">' + nameCellContent + '</span>' + '</div>';
  //   cellContent += '<span class="NeueFolderFilled listFolder" title="' + folderName + '"></span>'
  //   if(members == 1){
  //       nameCellContent  +='<span class="fileNameCont">'+folderName+'</span>' + '<span class="img-fav-icon-bg position-absolute">' + members + ' Member </span>' //<span class="Neuetag img-hash-tag-icon position-absolute"></span>
  //   }else{
  //       nameCellContent  +='<span class="fileNameCont">'+folderName+'</span>' + '<span class="img-fav-icon-bg position-absolute">' + members + ' Members </span>' //<span class="Neuetag img-hash-tag-icon position-absolute"></span>
  //   }
  //   return '<div class="sharelink-name">' + cellContent + '<span class="position-relative">' + nameCellContent + '</span>' + '</div>';
  // }
  
  public customNameCellRendererFunc(params): string {
    let nameCellContent:string = '';
    const objType = params.data.type;
    const fileExtension =  params.data.extension;
    const fileName = params.data.name;
    const folderName = params.data.FullObject.objectName;
    const sharedTab = params.data.shareDate?true:false;
    const favIcon = (params.data.showFavIcon == undefined)?true:params.data.showFavIcon
    const shareType = params.data.FullObject.shareType;
    const isShared = params.data.FullObject.isShared;
    const tfKey = params.data.FullObject.tfKey;

    
    if (objType != 'Folder') {
      if(params.data.FullObject["isFavorite"]){
          nameCellContent  +='<span class="fileNameCont listViewMarkedFileName ">'+fileName+'</span>'+'<span class="fileExtension listViewMarkedFileExtension">'+fileExtension+'</span>' + '<span class="NeueStarFilled img-fav-icon-bg list-file-icon position-absolute"></span>' //<span class="Neuetag img-hash-tag-icon position-absolute"></span>
        if(shareType){
          nameCellContent  +='<span class="'+ ((shareType == 'R' && isShared) ? 'NeueDuplicates' : '')+' img-share-icon-bg list-file-icon sec-icon position-absolute"></span>'
        }
      }else{
        nameCellContent  +='<span class="fileNameCont ' + ((shareType && shareType == 'R' && isShared) ? 'listViewMarkedFileName ' : '')  + '">'+fileName +'</span>'+'<span class="fileExtension ' + ((shareType && shareType == 'R' && isShared) ? 'listViewMarkedFileExtension' : '') + '">' + fileExtension + '</span>' 
        if(shareType){
          nameCellContent  +='<span class="'+ ((shareType == 'R' && isShared) ? 'NeueDuplicates' : '')+' img-share-icon-bg list-file-icon position-absolute"></span>'
        }
      }
    }else if (objType == 'Folder') {
        if(tfKey && params.data.members){
          nameCellContent  +='<span '+'class="folderNameAndSubTextCont cellId-' + params.data.objectId +'">'+folderName+'</span>'
          var members = params.data.members;
          nameCellContent += '<span class="subtextData position-absolute">'+ members + (members >1 ? ' Members' : " Member")+'</span>' 
        }else{
          nameCellContent  +='<span '+'class="folderNameCont cellId-' + params.data.objectId + '"title="'+folderName+'">'+folderName+'</span>'
        }
        // var classname = $('.cellId-'+params.data.objectId)[0] as any;
        // // classname.addEventListener('dragover', ()=>{
        // //   AppEvents.folderSpecificDragEvent.next({'hoveredObject':params.data.FullObject})
        // // }, false);
    }
    if(params.data.drag && params.data.drag == true){
      $(".ag-row").attr("draggable","true");
    }else{
      $(".ag-row").attr("draggable","false");
    }
    return nameCellContent;
  }

  public customOwnerNameCellRendererFunc(params): string {
    let ownerNameCellContent:string = '';
    const ownerName = params.data.sharedBy?params.data.sharedBy:params.data.owner;
    if(params.data.FullObject["isFavorite"]){
      ownerNameCellContent  +='<span class="ownerNameCont mb-3"'  + '"title="'+ownerName+'">' + ownerName +'</span>'
    }else{
      ownerNameCellContent  +='<span class="ownerNameCont"' + 'title="'+ownerName+'">' + ownerName +'</span>'
    }
    return ownerNameCellContent;
  }


  public customFavoriteTabCellRendererFunc(params): string {
    let nameCellContent:string = '';
    const objType = params.data.type;
    const fileExtension =  params.data.extension;
    const fileName = params.data.name;
    const folderName = params.data.FullObject.objectName;
    const shareType = params.data.FullObject.shareType;
    const isShared = params.data.FullObject.isShared;
    if (objType != 'Folder') {
        nameCellContent  +='<span class="fileNameCont '+ ((shareType && shareType == 'R' && isShared) ? 'listViewMarkedFileName ' : '')  +'">'+fileName+'</span>'+'<span class="fileExtension ' + ((shareType && shareType == 'R' && isShared) ? 'listViewMarkedFileExtension' : '')  + '">'+fileExtension+'</span>' 
        if(shareType){
          nameCellContent  +='<span class="'+ ((shareType == 'R' && isShared) ? 'NeueDuplicates' : '')+' img-share-icon-bg list-file-icon position-absolute"></span>'
        }
    }
    return nameCellContent;
  }
  
  constructor(
    public universalService:UniversalService,
    public contextMenuService:ContextMenuService,
    public router:Router, private applicationRef:ApplicationRef,public localStorageService:LocalStorageSvc,public globalService:GlobalService) { 
    if(!this.universalService.isMobileDevice){
      
    }

    var checkLogin =localStorage.jio;
    
    if (checkLogin) {
      this.universalService.userLoggedIn = true;
    } else {
      this.universalService.userLoggedIn = false;
    }
    
    this.setListOptions();
   
  }

  setListOptions(){
    if (this.universalService.userLoggedIn) {
      this.listOptions = { // list view general
        columnDefs: this.allFilesDefs,
        enableRangeSelection: true,
        rowDragManaged: false,
        rowMultiSelectWithClick: true,
        rowSelection: 'multiple',
        rowData: [],
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 50,
        comparator: this.comparator,
        postSortRows:this.postSort,
        suppressMultiSort:true,
        rowBuffer:10,
        suppressMaxRenderedRowRestriction:true,
        tooltipComponent: CustomImageTooltip,
        tooltipShowDelay : 1000,
        getRowClass : function(params) {
          return 'objectId'+params.data.objectId;
        }
      }

    
      if (jQuery(window).width() <= 991) {
        this.addToJCOptions = { // add to jc optiond
          columnDefs: this.columnMobileDefs1,
          rowSelection: 'single',
          rowData: null,
          paginationAutoPageSize: true,
          groupSelectsChildren: true,
          checkboxSelection: false,
          suppressCellSelection: true,
          rowHeight: 50,
          allowContextMenuWithControlKey: true,
          headerHeight: 1,
          rowBuffer:10
        }

        this.moveCopyOptions = { // move copy options for mobile
          columnDefs: this.moveCopyMobileDefs,
          rowSelection: 'single',
          rowData: null,
          paginationAutoPageSize: true,
          groupSelectsChildren: true,
          checkboxSelection: false,
          suppressCellSelection: true,
          rowHeight: 60,
          allowContextMenuWithControlKey: true,
          headerHeight: 1,
          rowBuffer:10,
          getRowClass : params => {
            if (params.node.data.FullObject.objectType == 'FE') {
                  return 'hideMoveCopyFile';
            }
          }
        }  
      } else{
      this.addToJCOptions = { // add to jc options for desktop
        columnDefs: this.addToJCColumnDefs,
        rowSelection: 'single',
        rowData: null,
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 50,
        allowContextMenuWithControlKey: true,
        headerHeight: 1,
        rowBuffer:10
      }

      this.moveCopyOptions  = { // move copy options
        columnDefs: this.moveCopyDefs,
        rowSelection: 'single',
        rowData: null,
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 60,
        allowContextMenuWithControlKey: true,
        headerHeight: 1,
        getRowClass : params => {
          if (params.node.data.FullObject.objectType == 'FE') {
                return 'hideMoveCopyFile';
          }
        }
      }
      
      this.audioPreviewOptions = {
        columnDefs: this.audioPreviewDefs,
        rowSelection: 'single',
        rowData: null,
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 50,
        allowContextMenuWithControlKey: true,
        headerHeight: 1
      }
      }
    } else {
      this.listOptions = { // list view general
        columnDefs: this.allFilesDefs,
        enableRangeSelection: true,
        rowDragManaged: false,
        rowMultiSelectWithClick: true,
        rowSelection: 'multiple',
        rowData: null,
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 50,
        comparator: this.comparator,
        postSortRows:this.postSort,
        suppressMultiSort:true,
        rowBuffer:10,
        suppressMaxRenderedRowRestriction:true,
        tooltipComponent: CustomImageTooltip,
        tooltipShowDelay : 1000
      }
      this.moveCopyOptions = { // move copy options for mobile
        columnDefs: this.moveCopyMobileDefs,
        rowSelection: 'single',
        rowData: null,
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 60,
        allowContextMenuWithControlKey: true,
        headerHeight: 1,
        rowBuffer:10
      }

      this.addToJCOptions = { // add to jc optiond
        columnDefs: this.columnMobileDefs1,
        rowSelection: 'single',
        rowData: null,
        paginationAutoPageSize: true,
        groupSelectsChildren: true,
        checkboxSelection: false,
        suppressCellSelection: true,
        rowHeight: 50,
        allowContextMenuWithControlKey: true,
        headerHeight: 1,
        rowBuffer:10
      }
    }
  }

  setEnvObjects(){
   this.cdstr = ApplicationRef;
  }

  ngOnChanges() {
    this.cdstr.tick();
  }

  postSort(rowNodes){
    AppEvents.folderSpecificDragEvent.next({"allNodes":rowNodes["nodes"]})
    rowNodes = rowNodes["nodes"]; // as per latest ag-grid update. fetching rowNodes as per latest structure.
    var index;
    if (rowNodes.length > 0 && rowNodes[0].data.isSortingRequired != undefined && rowNodes[0].data.isSortingRequired == false) {
      return false;
    }
     function isFolder(node) {
         return node.data.type === "Folder";
     }
     function move(toIndex, fromIndex) {
       rowNodes.splice(toIndex, 0, rowNodes.splice(fromIndex, 1)[0]);
     }
     var nextInsertPos = 0;
     rowNodes.map((node,index)=>{
         if (isFolder(node)) {
             move(nextInsertPos, index)
             nextInsertPos++;
         }
     })
  }

  deSelectAll(eve) {
    if(this.universalService.loadManageAccessComponent) {
      return false;
    }

    if(this.universalService.isAnyChange && (this.universalService.showShareWithPeople || this.universalService.showEnhancedShareLink || this.universalService.isManageTeamFolderMembers)) {
      this.universalService.disableModalBackdrop();
      return false;
    }
    
    this.universalService.disableModalBackdrop();
    this.universalService.mobileSelectionModeOn = false;
    this.universalService.isDesktopSelectionModeOn = false;
    this.headerCheckBoxChecked = false;
    this.deselectedNodesArray = [];
    if (this.universalService.listView && !this.universalService.isMobileDevice) {
      if(!this.universalService.showPreview && this.listOptions.api){
        this.listOptions.api.deselectAll();
        // this.universalService.selectedNodes = this.listOptions.api.getSelectedRows();
        this.universalService.selectedNodes = [];
      }
    } 
  
    else if(!this.universalService.showPreview && !this.universalService.selectionNodeNotNeedtoclear && !this.router.url.includes("/memory")){
      this.universalService.selectedNodes = [];
    }else{
      this.universalService.selectedFile = this.universalService.selectedNodes[0]
    }
    this.universalService.showTopMenu = false;
    this.universalService.hideTopMenuOptions();   
    this.universalService.popUpToBeOpened = "";
    this.universalService.operationInProgress = false;

    if(!this.universalService.showFileInfo)
      AppEvents.optionSelected.next({closeAll:true});
    
    AppEvents.privateFolderOperations.next({closeAll:true});
    AppEvents.virtualDOMObservable.next({closeAll:true});
    AppEvents.memorySubscriptions.next({closeAll:true});
    AppEvents.globalObservable.next({closeAll:true});
    AppEvents.memorySubscriptions.next({"decidetimer":true});
    this.parentFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
    if((this.universalService.popUpToBeOpened == "" )&& this.universalService.showPreview){
      this.universalService.selectedFile = this.universalService.selectedPreviewFile;
      this.universalService.showPreview = true;
    }else{
      this.universalService.showPreview = false;
    }
    if(this.universalService.isMobileDevice){
      this.universalService.disableModalBackdrop();
      this.universalService.showMobFileInfoPanel = false;
      this.universalService.showMobOptionMenu = false;
    }
    
    this.createAlbumObject = false;
    this.createFolderObject = false;
    this.universalService.showLoader = false;
    this.universalService.objectSelected = false;
    this.universalService.selectionNodeNotNeedtoclear = false;
    this.noFoldersPresent = false;
    this.universalService.clearSelection();
    this.contextMenuService.decideContextMenuItems();
    if(this.universalService.inAppWebViewOpened && this.universalService.currentTab == ""){
      this.informAndroidAndIOSToCloseWebView(eve);
    }
  }

  setHeaderHeight(height){
    // this.listOptions.api.setHeaderHeight(height)
    this.listOptions.api.updateGridOptions({'headerHeight':60});
  }

  resetColumnHeaders(){
    this.listOptions.columnDefs = [];
    this.listOptions.headerHeight = 0;
  }
  sendExtraDataToClientWebview(){
    
  }
  informAndroidAndIOSToCloseWebView(toastText) {
    var toastCode
    let statusflag ='';
    let userAppleId = '';
    let folderKey ='';
    this.universalService.loadOnlyStatusPage = false;
    toastText == undefined ? "" : toastText
    if(toastText != ""){
        toastCode = this.fetchCodeFromText(toastText)
    }
    $("body").removeAttr("style")
    return new Promise((resolve, reject) => {
      var backButtonPressed = false;
      if(this.universalService.currentTab != ""){ // if current tab is having the values of copy,sharedFiles,fileinfo,addpeople,newShareDisplay,newGrantAccessScreen
        backButtonPressed = true;
      }
      if(this.router.url.includes('/ioscloudbridge') || this.router.url.includes('/cloudbridge')){
        folderKey = this.localStorageService.getLocalProperty(LocalStorageProps.BACKUP_FOLDER_KEY,true)
        if(!folderKey || folderKey == null || folderKey == undefined || folderKey == ""){
          folderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
        }
      }
      if(this.router.url.includes('/ioscloudbridge')){
        this.IcloudBackupController = IcloudBackupController.getInstance(this.globalService);
        this.icloudImplRef = this.IcloudBackupController.icloudImplRef;
        const statuses = ['MI', 'MC', 'DI', 'DC', 'UI', 'AT', 'PS', 'MP','UC'];
        let matchCount = 0;
        if(this.icloudImplRef.transferList.length >=1){
          this.icloudImplRef.transferList.forEach((item) => {
            if(statuses.includes(item.backupStatus)) {
              matchCount++;
            }
          });
          if(matchCount === 1){
            if(this.icloudImplRef.transferList[0].backupStatus == "UC"){
              statusflag = "Completed"
              userAppleId = "";
            }else{
              statusflag = "In Progress"
              userAppleId = this.icloudImplRef.transferList[0].sourceEmailId;
            }
          }else{
            statusflag = "Conflict"
            userAppleId = "";
          }
        }else{
          statusflag = "Empty";
          userAppleId = "";
        }
      }
      
      const handle = "closeWebView";
      this.universalService.userLoggedIn = false;
      // this.universalService.inAppWebViewOpened = false;
      this.localStorageService.removeLocalProperty("nativeHeaders");
      USER_DETAILS["USER_DETAILS"]["rootFolderKey"] = '';
      // this.handlers[handle] = { resolve, reject};
      // alert("handle nativeHeadersHandler");
      
      var object = {};
      object["key1"] = "closeWebView",
      object["id"] = handle;
      object["showToast"] = toastCode;
      object["isBackPressed"] = backButtonPressed;
      object["objectDetails"] = this.objectDetails;
      object["iCloudFolderObjKey"] = folderKey;
      object["statusflag"] = statusflag ? statusflag : '';
      object["userAppleId"] = userAppleId ? userAppleId : '';
      if(this.objectDetails?.operationType == "fileinfo") {
        var fileName = {
          fileName: this.fileInfoRenameValue
        }
        object["objectDetails"]["additionalInfo"] = fileName;
      }
      
      if(this.universalService.activeRepo == "promo"){
        object["navigateUrl"] = toastText
      }
      
      if (this.universalService.iOSdevice) {
        (window as any).webkit.messageHandlers.closeWebView.postMessage(object);
      } else {
        (window as any).webkit.messageHandlers.closeWebView.postMessage(JSON.stringify(object));
      }
    });
  }

  fetchCodeFromText(toast){
    var msgs = Object.keys(WEBVIEW_MESSAGES);
    var msg = ""
    msgs.map(code=>{
      if(WEBVIEW_MESSAGES[code] == toast || code == toast){
        msg = code;
      }
    })
    return msg
  }

  getShareListViewSortOrder(){
    return (localStorage.getItem('listViewSortOrderShare'));
  }

  setShareListViewSortOrder(listViewSortOrderShare){
    this.listViewSortOrderShare = listViewSortOrderShare;
    localStorage.setItem('listViewSortOrderShare',listViewSortOrderShare);
  }

  getSharedLinkByMeSortOrder() {
    return (localStorage.getItem('sharedLinkByMeSortOrder'));
  }

  setSharedLinkByMeSortOrder(sharedLinkByMeSortOrder) {
    this.sharedLinkByMeSortOrder = sharedLinkByMeSortOrder;
    localStorage.setItem('sharedLinkByMeSortOrder',sharedLinkByMeSortOrder);
  }

  resetObjectSelections(showDefaultContextMenu=false,typeOfDefaultContextMenu='myfiles'){
    if (!this.universalService.listView) {
      let target = $(event.target).closest('.gridItem');
      if (target[0] == undefined) {
        $(".highlight-recent-item").removeClass("highlight-recent-item");
        this.universalService.mobileSelectionModeOn = false;
        this.universalService.isDesktopSelectionModeOn = false;
        this.universalService.showTopMenu = false;
        this.universalService.showAutoSuggestion = false;
        this.universalService.showShareSortingOptions = false;
        this.universalService.showPeopleSortMenu = false;
        this.universalService.hideTopMenuOptions();
        this.universalService.selectedNodes = [];
        this.universalService.hideEditAlbumDescBox = true;
        this.universalService.hideEditAlbumNameBox = true;
        this.universalService.clearSelection();
        this.contextMenuService.hideCustomContextMenu();
        AppEvents.virtualDOMObservable.next({closeAll:true})
        if(showDefaultContextMenu){
          this.universalService.contextMenuOptions = typeOfDefaultContextMenu == 'albums' ? this.universalService.albums_default_ContextMenu["FileMenu"] : this.universalService.myFiles_default_ContextMenu["FileMenu"]
        }
      }
    }else{
      let target = $(event.target).closest('.ag-center-cols-container');
      let selectAllTarget = $(event.target).closest('.ag-header-select-all');
      if (target[0] == undefined && selectAllTarget[0] == undefined) {
        $(".highlight-recent-item").removeClass("highlight-recent-item");
        var selectedNodes = [];
        selectedNodes = this.listOptions.api?.getSelectedRows();
        if(selectedNodes && selectedNodes.length > 0){
          this.listOptions.api?.deselectAll();
        }
        this.universalService.mobileSelectionModeOn = false;
        this.universalService.isDesktopSelectionModeOn = false;
        this.universalService.showAutoSuggestion = false;
        this.universalService.showShareSortingOptions = false;
        this.universalService.showPeopleSortMenu = false;
        this.universalService.showTopMenu = false;
        this.universalService.hideTopMenuOptions();
        this.universalService.selectedNodes = [];
        this.universalService.hideEditAlbumDescBox = true;
        this.universalService.hideEditAlbumNameBox = true;
        this.universalService.clearSelection();
        this.contextMenuService.hideCustomContextMenu();
        if(showDefaultContextMenu){
          this.universalService.contextMenuOptions = typeOfDefaultContextMenu == 'albums' ? this.universalService.albums_default_ContextMenu["FileMenu"] :this.universalService.myFiles_default_ContextMenu["FileMenu"]
        }
      }
    }
  }

  showDefaultContextMenuWhenClickedOnBlankArea(event,type='myfiles'){
    if(this.universalService.activeRepo != ActiveRepo.MAIN) return;
    if(this.universalService.selectedNodes.length == 0){
      this.contextMenuService.showCustomContextMenu(event);
      this.universalService.contextMenuOptions = type == 'albums' ? this.universalService.albums_default_ContextMenu["FileMenu"] : this.universalService.myFiles_default_ContextMenu["FileMenu"];
    }else{
      this.resetObjectSelections(true,type);
      setTimeout(() => {
        this.contextMenuService.showCustomContextMenu(event);
      }, 1);
    }
  }

  async getPPFTokenWithPassword(pfPassword){ 
    let userData = this.localStorageService.getUserData(true);
    let userId = userData["userId"];//this.localStorageService.getUserId(true)
    //let privateFolderSessionKey = this.localStorageService.getPrivateFolderSessionKey(true)
    let privateFolderSessionKey = userData["sessionKey"];
    if(userData && userData["privateFolder"] && userData["privateFolder"]["isPPFEnabled"] == "Y" && userData["privateFolder"]["allowPPF"] == "Y" && pfPassword != undefined && privateFolderSessionKey != undefined ){
      let currentTime = new Date();
      let ppfHash = this.universalService.passwordEncryptorUtil.getHash(userId, pfPassword);////userId,passPhrase
      let StringToEncrypt = userId + '#' + ppfHash+ '#' + currentTime.getTime();
      this.universalService.header_X_PPF_TOKEN = await this.universalService.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, privateFolderSessionKey)
    }
  }

  async getPPFToken(){ 
    let userData = this.localStorageService.getUserData(true);
    if(userData) {
      let userId = userData["userId"]; //this.localStorageService.getUserId(true)
      let pfPassword = this.localStorageService.getPrivateFolderPassword()
      //let privateFolderSessionKey = this.localStorageService.getPrivateFolderSessionKey(true)
      let privateFolderSessionKey = userData["sessionKey"];
      if(userData!=undefined && userData["privateFolder"] && userData["privateFolder"]["isPPFEnabled"] == "Y" && userData["privateFolder"]["allowPPF"] == "Y" && pfPassword != undefined && privateFolderSessionKey != undefined ){
        let currentTime = new Date();
        let ppfHash = this.universalService.passwordEncryptorUtil.getHash(userId, pfPassword);////userId,passPhrase
        let StringToEncrypt = userId + '#' + ppfHash+ '#' + currentTime.getTime();
        this.universalService.header_X_PPF_TOKEN = await this.universalService.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, privateFolderSessionKey)
      }
    }
  }
  resetTabHighlight(){
    let p= window.location.pathname
    let el = document.getElementById(p.split('/')[1])
    if(el && !el.classList.contains('active')){
      
      AppEvents.emit(EventsList.HIGHLIGHT_ACTIVE_TAB)
    }
  }
}



